import { OneDriveFile, OneDrivePackage } from 'owa-fileprovider-services';

export function getMimeTypeForOneDriveItem(item: {
    file?: OneDriveFile;
    package?: OneDrivePackage;
}): string {
    if (item.file) {
        return item.file.mimeType;
    } else if (item.package && item.package.type === 'oneNote') {
        // Client side calls do not return mimetypes for OneNote, so we check the package type.
        return 'application/onenote';
    } else {
        return null;
    }
}
